<template>
  <div class="p-grid">
    <div class="p-col-12 p-lg-5">
      <AppSkeletonCardForm v-if="loading" />
      <Card v-else>
        <template v-slot:title>Dados do Modelo</template>
        <template v-slot:content>
          <AppForm
            ref="form"
            :rules="rules"
            :values="form"
            v-slot:default="{ formErrors }"
          >
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12">
                <AppFormItem :error="formErrors.name" label="Nome">
                  <InputText v-model="form.name" />
                </AppFormItem>
              </div>
              <div class="p-field p-col-12">
                <AppFormItem label="Texto">
                  <InputText v-model="form.text" />
                </AppFormItem>
              </div>
              <div class="p-field p-col-6">
                <AppFormItem label="Logo 1">
                  <div class="image-container">
                    <AppUploadButton
                      v-if="!form.image1"
                      label="Adicionar Foto"
                      @upload="onUpload($event, 'image1')"
                      :maxSize="5 * 1024 * 1024"
                      :multiple="false"
                      :loading="loadingFile === 'image1'"
                    ></AppUploadButton>
                    <template v-else>
                      <img :src="form.image1.file.url" />
                      <Button
                        type="button"
                        icon="pi pi-times"
                        class="
                          p-button-rounded
                          p-button-text
                          p-button-secondary
                          p-shadow-3
                        "
                        @click="form.image1 = null"
                      ></Button>
                    </template>
                  </div>
                </AppFormItem>
              </div>
              <div class="p-field p-col-6">
                <AppFormItem label="Logo 2">
                  <div class="image-container">
                    <AppUploadButton
                      v-if="!form.image2"
                      label="Adicionar Foto"
                      @upload="onUpload($event, 'image2')"
                      :maxSize="5 * 1024 * 1024"
                      :multiple="false"
                      :loading="loadingFile === 'image2'"
                    ></AppUploadButton>
                    <template v-else>
                      <img :src="form.image2.file.url" />
                      <Button
                        type="button"
                        icon="pi pi-times"
                        class="
                          p-button-rounded
                          p-button-text
                          p-button-secondary
                          p-shadow-3
                        "
                        @click="form.image2 = null"
                      ></Button>
                    </template>
                  </div>
                </AppFormItem>
              </div>
            </div>
          </AppForm>
        </template>
        <template v-slot:footer>
          <div class="p-grid p-jc-end">
            <div style="padding-right: 8px">
              <router-link tag="span" :to="{ name: 'report-template.list' }">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <AppButton
                label="Salvar"
                @click="save()"
                :loading="loadingSave"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12 p-lg-7">
      <ReportTemplatePreview
        :text="form.text"
        :image1="form?.image1?.file?.url"
        :image2="form?.image2?.file?.url"
      ></ReportTemplatePreview>
    </div>
  </div>
</template>

<script>
import { ReportTemplateApi } from '../../services/api';
import ReportTemplatePreview from './components/ReportTemplatePreview.vue';

export default {
  name: 'ReportTemplateEdit',
  components: {
    ReportTemplatePreview,
  },
  data() {
    return {
      form: {
        name: '',
        text: '',
        image1: null,
        image2: null,
      },
      loading: false,
      loadingSave: false,
      loadingFile: false,
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
      },
    };
  },
  async created() {
    if (this.$route.params.id) {
      try {
        this.loading = true;
        const fetchResponse = await ReportTemplateApi.fetchById(
          this.$route.params.id
        );
        this.form = {
          ...this.form,
          ...fetchResponse,
          image1: fetchResponse.images.find((im) => im.position === 1),
          image2: fetchResponse.images.find((im) => im.position === 2),
        };
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    getDataToSave() {
      const images = [];
      if (this.form.image1) {
        images.push({ ...this.form.image1, position: 1 });
      }
      if (this.form.image2) {
        images.push({ ...this.form.image2, position: 2 });
      }
      return { ...this.form, images };
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.loadingSave = true;
        const body = this.getDataToSave();
        if (!this.$route.params.id) {
          await await ReportTemplateApi.create(body);
        } else {
          await await ReportTemplateApi.update(this.$route.params.id, body);
        }
        this.$router.push({ name: 'report-template.list' });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail: 'Não foi possível salvar o modelo de relatório.',
          life: 3000,
        });
      } finally {
        this.loadingSave = false;
      }
    },
    async onUpload(event, key) {
      try {
        this.loadingFile = key;
        const formData = new FormData();
        formData.append(`file`, event.files[0]);
        const file = await ReportTemplateApi.createImage(formData);
        this.form[key] = { file, fileId: file.id };
      } catch (error) {
        console.log(error);
        let detail = 'Não foi possível adicionar a foto.';
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail,
          life: 3000,
        });
      } finally {
        this.loadingFile = false;
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 180px;
  border: 1px solid #ced4da;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image-container img {
  max-width: 95%;
  max-height: 95%;
  object-fit: contain;
}

.image-container button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: white !important;
  height: 1.8rem !important;
  width: 1.8rem;
}
</style>
